<template>
  <Layout>
    <GoBack class="mb-5" text="shottracker news" link="Media" />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <div>
      <p class="text-lg mb-5">Upload new video</p>
      <VideoForm :form="videoForm" @handleSubmit="handleSubmit" />
    </div>
  </Layout>
</template>

<script>
import { uuid } from "vue-uuid";
import { mapActions, mapGetters } from "vuex";
import GoBack from "../../GoBack.vue";
import Layout from "../../Layout.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import VideoForm from "../Videos/VideoForm.vue";
import loader from "../../../mixins/loader";

export default {
  name: "UploadNewVideo",
  mixins: [loader],

  components: {
    Layout,
    VideoForm,
    GoBack,
    LoadingSpinner,
  },

  data() {
    return {
      videoForm: {
        link: "",
        title: "",
        description: "",
        featured: false,
        homeFeatured: false,
      },
    };
  },

  computed: {
    ...mapGetters(["videosID"]),
  },

  methods: {
    ...mapActions(["addVideoToS3"]),

    async handleSubmit() {
      const { link, title, description, featured, homeFeatured } =
        this.videoForm;

      const key = this.videosID.directoryKey;
      const uniqueID = uuid.v4();

      const newIndex = {
        link,
        title,
        description,
        featured,
        homeFeatured,
        id: uniqueID,
      };

      const video = { newIndex, key };

      await this.load(this.addVideoToS3(video), "Uploading video link");

      this.$router.push({
        name: "Media",
      });
    },
  },
};
</script>